import { datadogRum } from '@datadog/browser-rum';

export type ErrorMetadata = { [key: string]: unknown };

interface DatadogNotify {
  error: Error;
  metadata?: ErrorMetadata;
}

const datadogNotify = ({ error, metadata }: DatadogNotify) => {
  // Log to the console in development mode
  if (process.env.NODE_ENV === 'development')
    // eslint-disable-next-line no-console
    console.warn({ error, metadata });

  datadogRum.addError(error, metadata);
};

export default datadogNotify;
